/* eslint-disable jsx-a11y/anchor-is-valid */
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

//constants
//scss
import './DashboardPage.scss'
import {KTSVG, configData} from '../../../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {
  FrontendDashboardCalanderData,
  getFEdashboardCalander,
} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import moment from 'moment-timezone'
import {useEffect, useRef, useState} from 'react'
import {WSSelect} from '../../../../_metronic/helpers/components/WSSelect/WSSelect'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {useGetDashboardActivityOverviewGraphQuery} from '../../../../services/cellcast'
import {get} from 'lodash'
import ReactApexChart from 'react-apexcharts'
import NodataYet from '../../../Components/NodataYet'

const ConfigDashboard = ({whereWhen}: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const calendarRef: any = useRef(null)
  const calanderData = useSelector(getFEdashboardCalander)
  const [eventHoverInfo, setEventHoverInfo] = useState<any>(null)
  const [campType, setCampType] = useState('sms')
  const [mousePosition, setMousePosition] = useState({x: 0, y: 0})
  let options: any = [
    {value: 'sms', label: 'SMS'},
    {value: 'mms', label: 'MMS'},
  ]

  const FEActivity: any = useGetDashboardActivityOverviewGraphQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
    camp_type: campType,
  })

  const FEActivityData = get(FEActivity, 'data.data.[0]')

  const deliveredMessageCountData =
    FEActivityData?.deliveredMessageCount?.length > 0
      ? FEActivityData?.deliveredMessageCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []
  const inboundMessageCountData =
    FEActivityData?.inboundMessageCount?.length > 0
      ? FEActivityData?.inboundMessageCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []
  const replysMessageCountData =
    FEActivityData?.replysMessageCount?.length > 0
      ? FEActivityData?.replysMessageCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  const dataCreated = (val: any) => {
    const data = val?.map((key: any) => [+moment.utc(key?._id).format('x'), key?.count])

    return data?.length > 0 ? data : []
  }

  const activity: any = {
    series: [
      {
        name: `Delivered`,
        data: deliveredMessageCountData,
      },
      {
        name: `Inbound`,
        data: dataCreated(FEActivityData?.inboundMessageCount),
      },
      {
        name: `Replys`,
        data: replysMessageCountData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      noData: {
        text: 'No data yet',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
      },
    },
  }

  return (
    <>
      <div className='d-flex flex-row'>
        <div className='col-lg-12 py-6 calender-main'>
          <div className='card'>
            <div className='card-header border-botton-1  pt-5 pb-4'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-4 mb-1'>Activity overview</span>
              </h3>
              <div className='card-toolbar'>
                <WSSelect
                  value={campType}
                  onChange={(e: any) => setCampType(e.value)}
                  placeholder='All campaigns'
                  options={options}
                  className='w-150px me-4'
                />
                {/* <span className='btn btn-sm btn-primary py-3 px-5'>New message</span> */}
              </div>
            </div>
            <div className='card-body'>
              {FEActivity?.isLoading ? (
                <Spinner />
              ) : activity?.series.length > 0 ? (
                <div className=''>
                  <div className=''>
                    <ReactApexChart
                      options={activity.options}
                      series={activity.series}
                      type='area'
                      height={375}
                      width='100%'
                    />
                  </div>
                </div>
              ) : (
                <NodataYet message={'No data yet'} customeHight='100' />
              )}
            </div>
          </div>
        </div>
        {/* <div className='col-lg-3 p-1 mt-5'>
          <div className='card w-300px'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-4 mb-1'>Configurations</span>
                <span className='text-muted fw-light fs-8'>Integrations, API and more</span>
              </h3>
            </div>
            <div className='card-body'>
              {configData?.map((data, idx) => (
                <div className='row mb-5' key={idx}>
                  <div className='col-10'>
                    <h3 className='card-title d-flex align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-6'>{data.title}</span>
                    </h3>
                    <span className='text-muted fw-light fs-8 w-100px'>{data.description}</span>
                  </div>
                  <div className='col-2 d-flex flex-end p-1'>
                    <OverlayTrigger
                      placement='bottom'
                      overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                    >
                      <a
                        onClick={() => navigate(data?.path)}
                        className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                      >
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr064.svg'
                          className='svg-icon-2'
                        />
                      </a>
                    </OverlayTrigger>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </>
  )
}

export default ConfigDashboard
